import cn from "classnames"
import { useNavigate } from "react-router-dom"

import { Row } from "@/atoms"
import { FIXABLE_DATA_ID_ANALYTIC_FUNNEL_CARD } from "@/const/default-values"
import { useLogger } from "@/hooks/useLogger"
import { useNumberConvertor } from "@/hooks/useNumberConvertor"
import { useTranslation } from "@/hooks/useTranslation"
import { FunnelCard } from "@/molecules/FunnelCard"
import { helpers } from "."

import styles from "./Funnel.module.scss"

import type { FunnelComponent } from "."

export const Funnel: FunnelComponent = (props) => {
  const { numbers, fixableNumbers, size } = props
  const allValuesIsZero = helpers.isAllZero(numbers)
  const middleValuePath = size === "sm" ? 25 : 50
  const paths = helpers
    .getOffsets(numbers, allValuesIsZero, middleValuePath)
    .map(helpers.getPath(middleValuePath))

  const maxValue = numbers[0]
  const { abbreviateNumber } = useNumberConvertor()
  const { logger } = useLogger()
  const { t } = useTranslation()
  const {
    span,
    cards,
    getCards,
    loading,
    getColorsByIndex = helpers.getColorsByIndex
  } = props
  const navigate = useNavigate()

  return (
    <Row
      wrap={false}
      gutter={4}
      className={cn(styles.container, { [styles.small]: props.size === "sm" })}
    >
      {(cards || getCards(t)).map((card, index) => {
        const { key, link, ...rest } = card
        const flex = !span ? "1" : "none"
        const value = numbers[index] || 0
        const colorIndex = allValuesIsZero ? -1 : index
        const color = getColorsByIndex(colorIndex)
        const valueToDisplay = allValuesIsZero ? "-" : abbreviateNumber(value)
        const fixable = allValuesIsZero ? undefined : fixableNumbers?.[index]
        const extra = allValuesIsZero
          ? undefined
          : helpers.getPercentageDisplayValue(
              helpers.getPercentage(value, maxValue)
            )

        return (
          <FunnelCard
            key={key}
            id={key}
            loading={loading}
            span={span}
            flex={flex}
            size={size}
            to={link}
            d={paths[index]}
            maxViewBox={middleValuePath * 2}
            color={color}
            extra={extra}
            value={valueToDisplay}
            fixable={fixable}
            onClick={(event) => {
              const { MixPanelEvent } = props

              if (MixPanelEvent) {
                const isFixable =
                  ((event as Event)?.target as HTMLElement)?.dataset
                    ?.analyticEvent === FIXABLE_DATA_ID_ANALYTIC_FUNNEL_CARD

                logger.info(MixPanelEvent, {
                  card: key,
                  ...(isFixable ? { fixable: "yes" } : {})
                })
              }
            }}
            t={t}
            navigate={navigate}
            {...rest}
          />
        )
      })}
    </Row>
  )
}
